var _defs, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgC4WwwIconsWhiteSmartLighting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Line_Work",
    "data-name": "Line Work",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#fff;stroke-miterlimit:10;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "C4_WWW_Icons_White") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M69.6,41.57a19.6,19.6,0,1,0-39.2,0c0,13.75,11.85,15.45,11.8,20.67,0,1.14.89,5.42,2,5.42H55.82c1.09,0,1.94-4.28,2-5.42C58,57.26,69.6,54.84,69.6,41.57Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M57.62,69.31a1.86,1.86,0,0,0-1.93-1.79H44.31a1.8,1.8,0,1,0,0,3.58H55.69A1.86,1.86,0,0,0,57.62,69.31Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M57.62,73.48a1.86,1.86,0,0,0-1.93-1.79H44.31a1.8,1.8,0,1,0,0,3.58H55.69A1.86,1.86,0,0,0,57.62,73.48Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M57.62,77.65a1.86,1.86,0,0,0-1.93-1.79H44.31a1.8,1.8,0,1,0,0,3.59H55.69A1.87,1.87,0,0,0,57.62,77.65Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M53.51,81.13a1.83,1.83,0,0,0-1.86-1.8h-3.3a1.8,1.8,0,1,0,0,3.59h3.3A1.82,1.82,0,0,0,53.51,81.13Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgC4WwwIconsWhiteSmartLighting);
export default __webpack_public_path__ + "static/media/C4_WWW_Icons_White-Smart-Lighting.c35141ea9aca0fa8af0a37b88fd2b254.svg";
export { ForwardRef as ReactComponent };